export default "../images/vendor/leaflet/dist/layers.png?416d91365b44e4b4f4777663e6f009f3";